import styled from 'styled-components';
import { pxToRem } from 'styles/functions'

export const SCTopBarContainer = styled.div<{ $collapsed: boolean }>`
  position: relative;
  width: 100%;
  background-color: rgba(35, 35, 35, 0.75);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ $collapsed }) => ($collapsed ? `${pxToRem(5)} ${pxToRem(10)}` : `${pxToRem(10)}`)};
  height: ${({ $collapsed }) => ($collapsed ? '40px' : 'auto')};
  z-index: 12;

  @media (min-width: 768px) and (orientation: landscape) {
    width: calc(100% - ${pxToRem(91)});
  }
`

export const SCTopBarLabelWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-height: 10vh;
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 768px) and (orientation: landscape) {
    justify-content: center;
  }
`

export const SCTopBarLabel = styled.h2`
  font-weight: 600;
  color: white;
  font-size: ${pxToRem(18)};
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
  @media (min-width: 768px) and (orientation: landscape) {
    text-align: center;
    font-size: ${pxToRem(24)};
  }
  @media (min-width: 768px) and (orientation: portrait) {
    font-size: ${pxToRem(24)};
  }
`

export const SCToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  align-self: flex-end;
  margin-left: auto;
  padding: ${pxToRem(5)};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`

export const SCButtonIcon = styled.img`
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  color: white;
`